export default __webpack_public_path__ + "static/media/dreamwell.55f99f24.png";